import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fontsource+inter@5.2.8/node_modules/@fontsource/inter/400.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fontsource+inter@5.2.8/node_modules/@fontsource/inter/500.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fontsource+inter@5.2.8/node_modules/@fontsource/inter/600.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fontsource+inter@5.2.8/node_modules/@fontsource/inter/700.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fontsource+inter@5.2.8/node_modules/@fontsource/inter/cyrillic-400.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fontsource+inter@5.2.8/node_modules/@fontsource/inter/cyrillic-500.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fontsource+inter@5.2.8/node_modules/@fontsource/inter/cyrillic-600.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fontsource+inter@5.2.8/node_modules/@fontsource/inter/cyrillic-700.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/.pnpm/react-hot-toast@2.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/styles/theme-boxstore.css");
